(function () {
  if (window.jdrPanier) return;
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var r = window.routes || {};
  var urlAjout = (r.cart_add_url || racine + 'cart/add') + '.js';
  var urlModif = (r.cart_change_url || racine + 'cart/change') + '.js';
  var dernierFocus = null;

  function tiroir() { return document.getElementById('jdr'); }
  function panneau() { var t = tiroir(); return t && t.querySelector('.jdr__panneau'); }

  function ouvrir() {
    var t = tiroir();
    if (!t) return false;
    dernierFocus = document.activeElement;
    t.classList.add('is-open');
    t.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('jdr-bloque');
    setTimeout(function () { var p = panneau(); if (p) p.focus(); }, 60);
    return true;
  }

  function fermer() {
    var t = tiroir();
    if (!t) return;
    t.classList.remove('is-open');
    t.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('jdr-bloque');
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function alerte(msg) {
    var a = document.querySelector('[data-jdr-alerte]');
    if (!a) return;
    a.textContent = msg;
    a.hidden = !msg;
  }

  function majBulle(n) {
    var lien = document.getElementById('cart-icon-bubble');
    if (!lien) return;
    var bulle = lien.querySelector('.cart-count-bubble');
    if (n > 0) {
      if (!bulle) {
        bulle = document.createElement('div');
        bulle.className = 'cart-count-bubble';
        lien.appendChild(bulle);
      }
      bulle.innerHTML = '<span aria-hidden="true">' + (n < 100 ? n : '') + '</span>';
    } else if (bulle) {
      bulle.remove();
    }
  }

  function rafraichir() {
    return fetch(racine + '?sections=jdr-panier', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        var html = json && json['jdr-panier'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neuf = doc.getElementById('jdr');
        var t = tiroir();
        if (!neuf || !t) return;
        t.querySelector('.jdr__panneau').innerHTML = neuf.querySelector('.jdr__panneau').innerHTML;
        var n = parseInt(neuf.getAttribute('data-count') || '0', 10);
        t.setAttribute('data-count', n);
        majBulle(n);
      });
  }

  function texte(cle, defaut) {
    var t = tiroir();
    return (t && t.getAttribute('data-' + cle)) || defaut;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!tiroir()) return;
    e.preventDefault();
    var bouton = form.querySelector('[type="submit"]');
    if (bouton) { bouton.setAttribute('aria-busy', 'true'); bouton.classList.add('jdr-envoi'); bouton.disabled = true; }
    fetch(urlAjout, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
      .then(function (rep) {
        return rafraichir().then(function () {
          if (!rep.ok) alerte(texte('deja', rep.j && rep.j.description) || '');
          ouvrir();
        });
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (bouton) { bouton.removeAttribute('aria-busy'); bouton.classList.remove('jdr-envoi'); bouton.disabled = false; }
      });
  });

  document.addEventListener('click', function (e) {
    var icone = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (icone && tiroir()) {
      e.preventDefault();
      ouvrir();
      rafraichir();
      return;
    }
    if (e.target.closest && e.target.closest('[data-jdr-close]')) {
      e.preventDefault();
      fermer();
      return;
    }
    var retirer = e.target.closest && e.target.closest('[data-jdr-remove]');
    if (retirer) {
      e.preventDefault();
      var ligne = retirer.closest('.jdr__piece');
      if (ligne) ligne.style.opacity = '.4';
      fetch(urlModif, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: retirer.getAttribute('data-jdr-remove'), quantity: 0 }),
        credentials: 'same-origin'
      }).then(rafraichir).then(function () { var p = panneau(); if (p) p.focus(); });
    }
  });

  document.addEventListener('keydown', function (e) {
    var t = tiroir();
    if (!t || !t.classList.contains('is-open')) return;
    if (e.key === 'Escape') { fermer(); return; }
    if (e.key !== 'Tab') return;
    var f = t.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) rafraichir(); });

  window.jdrPanier = { ouvrir: ouvrir, fermer: fermer, rafraichir: rafraichir };
})();
